/** Keep Thai combining marks with their base; full identity remains available on selection. */
export function fitActorLabelText(text:string,maxWidth:number,measure:(text:string)=>number):string{
 if(measure(text)<=maxWidth)return text;
 const parts=[...new Intl.Segmenter('th',{granularity:'grapheme'}).segment(text)].map(part=>part.segment);
 if(measure('…')>maxWidth)return '';
 let low=0,high=parts.length;
 while(low<high){const middle=Math.ceil((low+high)/2);if(measure(parts.slice(0,middle).join('')+'…')<=maxWidth)low=middle;else high=middle-1;}
 return parts.slice(0,low).join('')+'…';
}
